import bankStyles from '../../assets/css/banks.module.css';
import { Paper } from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { selectPrimaryColor, selectSecondaryColor } from '../../app/slices/configuration.slice';
import { useState } from 'react';

interface BankComponentProps {
	logo: JSX.Element;
	title: JSX.Element;
	icon?: JSX.Element | null;
	isSkeleton?: boolean;
	onBankComponentClick(): void;
}

export const BankComponent = ({ title, icon, logo, isSkeleton = false, onBankComponentClick }: BankComponentProps) => {
	const primaryColor = useAppSelector(selectPrimaryColor);
	const secondaryColor = useAppSelector(selectSecondaryColor);
	const [hover, setHover] = useState(false);

	const sectionStyle = {
		cursor: 'pointer',
		backgroundColor: hover ? secondaryColor : undefined,
		boxShadow: hover
			? ` 0px 2px 1px -1px ${primaryColor}, 0px 1px 1px 0px ${primaryColor}, 0px 1px 3px 0px  ${primaryColor}`
			: undefined,
		transform: 'scale(1.02)'
	};

	return (
		<div className={bankStyles['bank-row-outer-container']}>
			<Paper
				elevation={1}
				className={`${bankStyles['bank-row-container']} ${isSkeleton && bankStyles['bank-row-skeleton']} ${
					isSkeleton && 'bank-row-skeleton'
				}`}
				style={sectionStyle}
				onMouseEnter={() => setHover(true)}
				onMouseLeave={() => setHover(false)}
				onClick={onBankComponentClick}
			>
				<div className={`${bankStyles['bank-row']} bank-row`}>
					<div className={bankStyles['bank-content']}>
						<div className={bankStyles['bank-content-logo']}>
							<div className={bankStyles['bank-logo-container']}>{logo}</div>
						</div>
						<div className={bankStyles['bank-content-name']}>{title}</div>
					</div>
					{icon && <div className={bankStyles['bank-select-icon']}>{icon}</div>}
				</div>
			</Paper>
		</div>
	);
};
